/* Crevel — new web: hero slider + carousels (no dependencies) */
(function(){
  function initHero(root){
    if(!root || root.dataset.crvnwReady) return; root.dataset.crvnwReady='1';
    var slides=[].slice.call(root.querySelectorAll('.crvnw-slide'));
    var dots=[].slice.call(root.querySelectorAll('.crvnw-hero__dots button'));
    if(slides.length<2) return;
    var i=0, delay=(parseInt(root.dataset.autoplay,10)||7)*1000, timer=null;
    function go(n){
      i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);s.setAttribute('aria-hidden',k===i?'false':'true');});
      dots.forEach(function(d,k){d.setAttribute('aria-current',k===i?'true':'false');});
    }
    function play(){stop(); if(delay>0) timer=setInterval(function(){go(i+1);},delay);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);play();});});
    var p=root.querySelector('.crvnw-hero__arrow--prev'), n=root.querySelector('.crvnw-hero__arrow--next');
    if(p) p.addEventListener('click',function(){go(i-1);play();});
    if(n) n.addEventListener('click',function(){go(i+1);play();});
    root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',play);
    root.addEventListener('focusin',stop);
    var x0=null;
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45){go(dx<0?i+1:i-1);play();}x0=null;});
    go(0); play();
    root.addEventListener('crvnw:select',function(e){go(e.detail);stop();});
  }
  function initCarousel(root){
    if(!root || root.dataset.crvnwReady) return; root.dataset.crvnwReady='1';
    var track=root.querySelector('[data-crvnw-track]'); if(!track) return;
    function step(){var c=track.querySelector(':scope > *');return c?c.getBoundingClientRect().width+24:300;}
    root.querySelectorAll('[data-crvnw-prev]').forEach(function(b){b.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});});
    root.querySelectorAll('[data-crvnw-next]').forEach(function(b){b.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});});
  }
  function initAll(scope){
    (scope||document).querySelectorAll('[data-crvnw-hero]').forEach(initHero);
    (scope||document).querySelectorAll('[data-crvnw-carousel]').forEach(initCarousel);
  }
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
  document.addEventListener('shopify:block:select',function(e){
    var slide=e.target.closest && e.target.closest('.crvnw-slide'); if(!slide) return;
    var hero=slide.closest('[data-crvnw-hero]'); if(!hero) return;
    var idx=[].indexOf.call(hero.querySelectorAll('.crvnw-slide'),slide);
    hero.dispatchEvent(new CustomEvent('crvnw:select',{detail:idx}));
  });
})();

/* Crevel — keep the visitor's language: prefix internal links with the locale root (/de/, /es/, /nl/) */
(function(){
  var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  if(r==='/'||window.__crvLocLinks) return; window.__crvLocLinks=1;
  var skip=/^\/(cdn|checkout|checkouts|cart\/(add|change|update|clear)|account\/logout|apps\/|tools\/|services\/|recommendations\/|search\/suggest|policies\/|\.well-known)/;
  function fix(a){
    var h=a.getAttribute('href');
    if(!h||h.charAt(0)!=='/'||h.charAt(1)==='/') return;
    if(h.indexOf(r)===0||h+'/'===r||skip.test(h)) return;
    a.setAttribute('href',r+h.slice(1));
  }
  function all(root){ (root||document).querySelectorAll('a[href^="/"]').forEach(fix); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){all();}); else all();
  document.addEventListener('click',function(e){ var a=e.target.closest&&e.target.closest('a[href^="/"]'); if(a) fix(a); },true);
  if(window.MutationObserver) new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes.forEach(function(n){ if(n.nodeType===1){ if(n.matches&&n.matches('a[href^="/"]')) fix(n); all(n); } }); }); }).observe(document.documentElement,{childList:true,subtree:true});
})();
